import React, { useEffect, useContext, useState } from "react";
import { Divider } from "antd";
import ChiefComplaints from "./ChiefComplaints/ChiefComplaints";
import PresentIllness from "./PresentIllness/PresentIllness";
import TreatmentHistory from "./TreatmentHistory/TreatmentHistory";
import PersonalHistory from "./PersonalHistory/PersonalHistory";
import FunctionalCapacity from "./FunctionalCapacity/FunctionalCapacity";
import PastSurgicalHistory from "./PastSurgicalHistory/PastSurgicalHistory";
import Informant from "./Informant/Informant";
import "./HistoryForm.css";
import PastMedicalHistory from "./PastMedicalHistory/PastMedicalHistory";

import KnownAllergies from "./KnownAllergies/KnownAllergies";

const DoctorHistoryForm = ({ form, context, editId }) => {
  const [refresh, setRefresh] = useState(false);
  const refreshHistory = () => {
    setRefresh((prev) => !prev);
  };
  const { formData } = useContext(context);

  useEffect(() => {
    const dataToSet = formData?.history || formData;

    if (dataToSet && Object.keys(dataToSet).length > 0) {
      form.setFieldsValue(dataToSet);
      setTimeout(() => {
        refreshHistory();
      }, 1000);
    }
  }, [formData, editId]);

  return (
    <>
      <Informant context={context} form={form} />
      <Divider />
      <ChiefComplaints context={context} form={form} />
      <Divider />
      <PresentIllness context={context} form={form} />
      <Divider />
      <TreatmentHistory context={context} form={form} />
      <Divider />
      <PastMedicalHistory context={context} form={form} />
      <Divider />
      <PastSurgicalHistory form={form} context={context} />
      <Divider />
      <PersonalHistory form={form} />
      <Divider />
      <FunctionalCapacity form={form} />
      <Divider />
      <KnownAllergies context={context} form={form} />
      <Divider />
    </>
  );
};

export default DoctorHistoryForm;
